import { render, staticRenderFns } from "./PageStadiumBoosts.vue?vue&type=template&id=04016f74&"
import script from "./PageStadiumBoosts.vue?vue&type=script&lang=js&"
export * from "./PageStadiumBoosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04016f74')) {
      api.createRecord('04016f74', component.options)
    } else {
      api.reload('04016f74', component.options)
    }
    module.hot.accept("./PageStadiumBoosts.vue?vue&type=template&id=04016f74&", function () {
      api.rerender('04016f74', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PageStadiumBoosts.vue"
export default component.exports